module.exports = {"basicInfo":"Basic Informantion","sales_username":"Sales Person","wholesaler":"Wholesaler","invoice":"Invoice","individual_tour_name":"Individual Tour Name","customer_source":"Customer Source","note":"Remark","num_of_room":"Number of Room","itinerary":{"start_date":"Start Date","end_date":"End Date","duration":"Duration","destination":"Destination","pickup_date":"Pickup Date"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/individualtour/create/information.json
// module id = C0s8
// module chunks = 58